import React from 'react';
import styled from 'styled-components';

import TableItems from './TableItems';

import { AesDes } from '../../../components/elements';

const BookingManagerTableContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  padding: 0 15px;
  margin: 6px 0;
`;

const BookingManagerTableItems = styled.div`
  border: 1px solid #e2e2e2;
  font-size: 18px;
  color: black;
  padding: 10px;
  text-align: center;
`;

const LoadingText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #00aeef;
  font-size: 24px;
`;

const BookingManagerTable = ({
  tableBookingLoading,
  tableBookings,
  placeId,
  history,
  sort,
  setSort,
  tab,
}) => (
  <>
    <BookingManagerTableContainer>
      <BookingManagerTableItems
        style={{ fontWeight: '500', backgroundColor: '#b0b0b0' }}
      >
        <AesDes
          sort={sort}
          setSort={setSort}
          aes={tab === 1 ? 'CREATED_AT_ASC' : 'DATE_TIME_BY_ASC'}
          des={tab === 1 ? 'CREATED_AT_DESC' : 'DATE_TIME_BY_DESC'}
        />
        &nbsp; Time
      </BookingManagerTableItems>
      <BookingManagerTableItems
        style={{ fontWeight: '500', backgroundColor: '#b0b0b0' }}
      >
        <AesDes
          sort={sort}
          setSort={setSort}
          aes="GUEST_BY_ASC"
          des="GUEST_BY_DESC"
        />
        &nbsp; Guests / Table
      </BookingManagerTableItems>
      <BookingManagerTableItems
        style={{ fontWeight: '500', backgroundColor: '#b0b0b0' }}
      >
        Booking Name
      </BookingManagerTableItems>
      <BookingManagerTableItems
        style={{ fontWeight: '500', backgroundColor: '#b0b0b0' }}
      >
        <AesDes
          sort={sort}
          setSort={setSort}
          aes="BOOKING_FEE_BY_ASC"
          des="BOOKING_FEE_BY_DESC"
        />
        &nbsp; Booking Fee
      </BookingManagerTableItems>
      <BookingManagerTableItems
        style={{ fontWeight: '500', backgroundColor: '#b0b0b0' }}
      >
        Contact
      </BookingManagerTableItems>
      <BookingManagerTableItems style={{ backgroundColor: '#b0b0b0' }}>
        Status / Action
      </BookingManagerTableItems>
      {tableBookings.map((ele, idx) => (
        <TableItems
          tab={tab}
          ele={ele}
          idx={idx}
          placeId={placeId}
          history={history}
        />
      ))}
    </BookingManagerTableContainer>
    {tableBookingLoading && <LoadingText>Loading...</LoadingText>}
  </>
);

export default BookingManagerTable;
